<ngx-loading-bar
  #loading
  color="#3AA36B"
  includeSpinner="false"
  height="3px"
></ngx-loading-bar>

<app-filter
  [typeComponent]="typeComponent"
  (expFilter)="translateFilter($event)"
></app-filter>

<app-pagination
  [currentUrl]="currentUrl"
  [total]="totalInvoices"
  (setPag)="setPag($event)"
></app-pagination>

<app-list
  [dataList]="dataList"
  [currentUrl]="currentUrl"
  [currencyColumn]="4"
></app-list>

<app-pagination
  [currentUrl]="currentUrl"
  [total]="totalInvoices"
  (setPag)="setPag($event)"
></app-pagination>
